import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { HelperProvider } from 'src/app/providers/helper.provider';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-share-access-edit',
  templateUrl: './share-access-edit.page.html',
  styleUrls: ['./share-access-edit.page.scss'],
})
export class ShareAccessEditPage implements OnInit {
  @Input() data: any;
  @Input() item: any;
  ownerForm: FormGroup;
  accessLevel = "";
  constructor(
    private modalController: ModalController,
    private formBuilder: FormBuilder,
    private helperProvider: HelperProvider,
    private translationService: TranslateService
  ) { 
    
  }

  ngOnInit() {
    this.accessLevel = this.item?.accessLevel;
    console.log("Otem", this.item);
  }

  goBack() {
    this.modalController.dismiss();
  }

  saveAndRefresh() {
    this.modalController.dismiss({ refresh: true });
  }

  async removeAccess() {
    try {
      // const t2 = await this.helperProvider.showAlert(`Are you sure you want to remove access?`)
      const t2 = await this.helperProvider.showAlert(this.translationService.instant("record.remove_access_head"), this.translationService.instant("record.remove_access_desc"))
      if (t2) {
        await this.helperProvider.startLoading();
        await this.helperProvider.getMyData({ officeId: environment.SEPTIC_OFFICE_ID, regId: environment.SENSOR_USER_REG_ID, sensorId: this.data._id, recId: this.item._id, type: "actionClick", actionType: "removeUserAccess", accessLevel: this.accessLevel });
        await this.helperProvider.closeLoading();
        await this.helperProvider.showAlert(this.translationService.instant("record.info"), this.translationService.instant("record.remove_access_success"));
        this.saveAndRefresh();
      }
    } catch (error) {
      this.helperProvider.showAlert(this.translationService.instant("record.error"), error);
      await this.helperProvider.closeLoading();
    }
  }

  async update() {
    try {
      await this.helperProvider.startLoading();
      await this.helperProvider.getMyData({ officeId: environment.SEPTIC_OFFICE_ID, regId: environment.SENSOR_USER_REG_ID, sensorId: this.data._id, recId: this.item._id, type: "actionClick", actionType: "updateUserAccess", accessLevel: this.accessLevel });
      await this.helperProvider.closeLoading();
      await this.helperProvider.showToast(this.translationService.instant("record.user_access_updated_success"));
      this.goBack();
    } catch (error) {
      this.helperProvider.showAlert(this.translationService.instant("record.error"), error);
      await this.helperProvider.closeLoading();
    }
  }

  selectChange(eve) {
    console.log("eve", eve);
    this.update();
  }
}
